import DashboardDesempenho from '@/views/desempenho/DashboardDesempenho';
import DesempenhoComportamental from '@/views/desempenho/comportamento/DesempenhoComportamental';
import DesempenhoResponsabilidade from '@/views/desempenho/responsabilidade/DesempenhoResponsabilidade';
import CoeficienteDesempenho from '@/views/desempenho/CoeficienteDesempenho';

const DesempenhoRoutes = [
  {
    path: '/desempenho',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Desempenho' },
      ],
      requiresAuth: true,
    },
    name: 'DashboardDesempenho',
    component: DashboardDesempenho,
  },
  {
    path: '/desempenho/comportamental',
    name: 'DesempenhoComportamental',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Desempenho', href: '/desempenho' },
        { position: 3, text: 'Desempenho Comportamental' },
      ],
      requiresAuth: true,
    },
    component: DesempenhoComportamental,
  },
  {
    path: '/desempenho/responsabilidade',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Desempenho', href: '/desempenho' },
        { position: 3, text: 'Desempenho Técnico' },
      ],
      requiresAuth: true,
    },
    name: 'DesempenhoResponsabilidade',
    component: DesempenhoResponsabilidade,
  },
  {
    path: '/desempenho/coeficiente',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Desempenho', href: '/desempenho' },
        { position: 3, text: 'Coeficiente de Desempenho do Servidor (CDS)' },
      ],
      requiresAuth: true,
    },
    name: 'CoeficienteDesempenho',
    component: CoeficienteDesempenho,
  },
];

export default DesempenhoRoutes;
